import { api_portalOfficeHospitalListing_medicalSubject } from '@/init/swagger';
import NoImagePNG from '@/../public/no-image.png';
import { getPostCode } from '@/helpers/postCodeHelper';
import { getPrefName } from '@/data/prefectures';
import dayjs from '@/init/dayjs';
import { HospitalListingOutput } from '@/helpers/parseHospitalListings';

type Props = {
  hospitalMedicalSubjects: api_portalOfficeHospitalListing_medicalSubject[];
  listingInfo: HospitalListingOutput;
};

export const useLogic = ({ hospitalMedicalSubjects, listingInfo }: Props) => {
  const thumbnailInfo = {
    image:
      listingInfo.portal_office_hospital_listing_image?.image1_url ||
      NoImagePNG.src,
    alt: listingInfo.portal_office_hospital_listing_image?.image1 || 'NO IMAGE',
  };

  const {
    portal_office: portalOfficeData,
    portal_office_hospital_listing_medical_subjects:
      portalOfficeMedicalSubjects,
    official_hp_url: hpUrl,
  } = listingInfo;

  const {
    post_code,
    pref = 0,
    city = '',
    area = '',
    building = '',
    tel_area,
    tel_city,
    tel_num,
    listing_updated_at,
  } = portalOfficeData;

  const postCode = post_code ? `〒${getPostCode(post_code)}` : '';
  const address = `${getPrefName(pref)}${city}${area}${building}`;
  const tel =
    tel_area && tel_city && tel_num ? `${tel_area}-${tel_city}-${tel_num}` : '';

  const medicalSubjects =
    portalOfficeMedicalSubjects
      .map(
        (portalItem) =>
          hospitalMedicalSubjects.find(
            (masterItem) => masterItem.id === portalItem.medical_subject_id,
          )?.label,
      )
      .join('・') || '';

  const updatedAt = listing_updated_at
    ? dayjs(listing_updated_at).format('YY.M.D')
    : '-';

  const portalOfficeInfo = {
    name: listingInfo.portal_office?.name,
    postCode,
    address,
    tel,
    medicalSubjects,
    hpUrl,
    updatedAt,
  };

  const isCarelogood = listingInfo.portal_office?.is_carelogood === true;

  return {
    thumbnailInfo,
    portalOfficeInfo,
    isCarelogood,
  };
};
